/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/



// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import { Grid } from "@mui/material";


// Soft UI Dashboard PRO React example components

// SmartHome dashboard components

// Data


//Backend access
import { useQuery } from '@tanstack/react-query';
import { getCameraImage, loadToken } from 'services/api/bks';
import PropTypes from "prop-types";



import { useAuth0 } from "@auth0/auth0-react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { loadingScreen } from "utils/wrapper";
import { useSoftUIController } from "hooks/context";

// Images



function CameraImage({ image_id }) {

  loadToken(useAuth0());

  const [controller] = useSoftUIController();
  const { deviceLayout } = controller;

  // console.log(image_data)
  // debugger;
  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ['getCameraImage', image_id],
    queryFn: async () => {
      const data = await getCameraImage(image_id);
      return data;
    },
    staleTime: Infinity,
  });

  if (isLoading) {
    return (
      <SoftBox height="100%" my={5}>
        {loadingScreen(deviceLayout, false)}
      </SoftBox>
    )
  }

  if (error) {
    return "Error! " + error.message;
  }

  const blob = new Blob([data]);
  const url = URL.createObjectURL(blob);

  return (
    <PhotoProvider id={blob}>
      <SoftBox sx={{ height: "100%" }}>
        <PhotoView src={url}>
          <SoftBox
            component="img"
            src={url}
            borderRadius="lg"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain"
            }}
          />
        </PhotoView>
      </SoftBox>
    </PhotoProvider >
  );
}

// Typechecking props for the CameraImage
CameraImage.propTypes = {
  image_id: PropTypes.string
};


export default CameraImage;
